export const getMyHomeLink = (address: string): string => {
  return `/my-home/?address=${address}&from=card_jk_price_dynamics`;
};
